import React from 'react';
import { Box, Container, Typography, Link as MuiLink, useTheme } from '@mui/material';
import Card from '../ui/Card';
import Button from '../ui/Button';

export const RFQFormSection: React.FC = () => {
  const theme = useTheme();

  const handleScrollToContact = () => {
    window.location.href = 'mailto:sales@inverika.com?subject=Project%20Inquiry%20-%20Inverika';
  };

  return (
    <Box
      id="contact"
      sx={{
        py: { xs: 10, md: 14 },
        backgroundColor: theme.palette.background.default,
        transition: 'background-color 0.3s ease',
      }}
    >
      <Container maxWidth="xl">
        <Card
          glass
          sx={{
            p: { xs: 6, md: 8 },
            borderColor: theme.palette.primary.main,
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {/* Subtle Glow Overlay */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: 380,
              height: 380,
              backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0, 102, 255, 0.1)' : 'rgba(0, 80, 203, 0.08)',
              filter: 'blur(100px)',
              pointerEvents: 'none',
            }}
          />

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: 'space-between',
              alignItems: { xs: 'flex-start', md: 'center' },
              gap: 4,
              position: 'relative',
              zIndex: 1,
            }}
          >
            <Box sx={{ maxWidth: 680 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2rem', md: '3rem' },
                  color: theme.palette.text.primary,
                  fontFamily: 'Space Grotesk',
                  fontWeight: 700,
                  mb: 2,
                }}
              >
                Have a Project Requirement?
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: theme.palette.text.secondary, fontSize: '1.15rem', mb: 4, lineHeight: 1.6 }}
              >
                Talk to our technical team about your Bill of Quantities (BOQ), design scope, or infrastructure challenges.
              </Typography>

              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                <MuiLink
                  href="tel:+916366322532"
                  underline="none"
                  sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: theme.palette.text.primary, '&:hover': { color: theme.palette.primary.main } }}
                >
                  <span className="material-symbols-outlined" style={{ color: theme.palette.primary.main }}>call</span>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>+91-6366322532</Typography>
                </MuiLink>

                <MuiLink
                  href="mailto:sales@inverika.com"
                  underline="none"
                  sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: theme.palette.text.primary, '&:hover': { color: theme.palette.primary.main } }}
                >
                  <span className="material-symbols-outlined" style={{ color: theme.palette.primary.main }}>mail</span>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>sales@inverika.com</Typography>
                </MuiLink>

                <MuiLink
                  href="https://wa.me/916366322532"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="none"
                  sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: theme.palette.text.primary, '&:hover': { color: theme.palette.primary.main } }}
                >
                  <span className="material-symbols-outlined" style={{ color: theme.palette.primary.main }}>chat</span>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>WhatsApp Us</Typography>
                </MuiLink>
              </Box>
            </Box>

            <Button
              variant="contained"
              size="large"
              glow
              onClick={handleScrollToContact}
              sx={{
                px: 5,
                py: 2.5,
                fontSize: '1.1rem',
                fontFamily: 'Space Grotesk',
                fontWeight: 600,
                whiteSpace: 'nowrap',
              }}
            >
              Initiate Discussion
            </Button>
          </Box>
        </Card>
      </Container>
    </Box>
  );
};

export default RFQFormSection;
